import { maybeUnprocessBranch } from '../store/flow-branches/action-creators';
import { FlowActionTypes } from '../store/flow/action-types';
import { getCurrentStep } from '../store/flow/selectors';
import { executeStepBefore } from '../views/getStepConfig';
import { setNextStep } from './setNextStep';
import { isOutdatedStepCompletedAction, shouldGoNextStep } from './stepperMiddlewareUtils';
export const StepperMiddleware = store => next => action => {
  const result = next(action);
  const currentStep = getCurrentStep(store.getState());

  if (action.type === FlowActionTypes.SetFlow) {
    store.dispatch(setNextStep());
    return result;
  }

  if (action.type === FlowActionTypes.GoPrevStep) {
    store.dispatch(maybeUnprocessBranch());
    return result;
  }

  if (currentStep) {
    if (isOutdatedStepCompletedAction(action, currentStep)) {
      return result;
    }

    if (action.type === FlowActionTypes.StepCompleted) {
      store.dispatch(executeStepBefore(currentStep));
    }

    if (shouldGoNextStep(action, currentStep)) {
      store.dispatch(setNextStep());
    }
  }

  return result;
};